import { loader } from 'graphql.macro'

export default function reportsTicketDetailsQuery ({ dataLoaders, queryKey }) {
  const [,
    startDate,
    endDate,
    resourceType,
    drivers,
    status,
    yearToDate
  ] = queryKey

  const reportsTicketDetailsSchema = loader('./reportsTicketDetails.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsTicketDetailsSchema, { startDate, endDate, resourceType, drivers, status, yearToDate })
}
